<template>
  <ElSelect
    class="multi-select"
    :value="value"
    multiple
    :filterable="filterable"
    :placeholder="placeholder"
    :loading-text="$t('LOADING_DATA')"
    popper-class="multi-select__dropdown"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @change="$emit('change', $event)"
  >
    <ElOption
      v-for="item in items"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
      <i
        :class="value.includes(item.value) ? 'el-icon-check' : 'el-icon-plus'"
      />
      <span>{{ item.label }}</span>
    </ElOption>
  </ElSelect>
</template>

<script>
export default {
  name: 'MultiSelect',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    filterable: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.multi-select {
  .el-tag {
    background: #f5f7fa;
    color: #606266;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  .el-icon-close {
    color: #606266 !important;
    background-color: transparent !important;
  }

  &__dropdown {
    .el-select-dropdown__item.selected::after {
      display: none;
    }
  }
}
</style>
